import { createContext, useContext, type ReactNode } from 'react';

export type Locale = 'en' | 'ta';

const TA: Record<string, string> = {
  'Opening Nayanmar Trails…': 'தளம் தயாராகிறது…',
  'DEVOTION CONNECTS LANDS': 'பக்தி இணைத்த திருத்தலங்கள்',
  'Explore': 'சுற்றிப் பாருங்கள்',
  'Journeys': 'பயணங்கள்',
  'Sthalams': 'திருத்தலங்கள்',
  'Sources': 'ஆதாரங்கள்',
  'Connections': 'தொடர்புகள்',
  'Ancient Paths': 'பழம்பாதைகள்',
  'Living Today': 'இன்றும் வாழும் மரபு',
  'ANCIENT PATHS · LIVING DEVOTION': 'பழம்பாதைகள் · இன்றும் வாழும் பக்தி',
  'Follow the Nayanmars across sacred Tamil Nadu': 'நாயன்மார்களின் திருத்தலப் பாதையில் தமிழகம் முழுவதும் பயணிப்போம்',
  'Explore sthalams, Tēvāram pathigams, saint traditions and the sacred geography that connects them.': 'திருத்தலங்கள், தேவாரப் பதிகங்கள், பெரியபுராண மரபுகள்—இவற்றை இணைக்கும் புனிதப் புவியியலை அறியுங்கள்.',
  'Not just history, but a living landscape of devotion.': 'இது பழைய வரலாறு மட்டும் அல்ல; இன்றும் வழிபாட்டில் வாழும் பக்தியின் பாதை.',
  'Saint': 'நாயன்மார்',
  'Naalvar': 'நால்வர்',
  '63 Nayanmar registry': 'அறுபத்து மூவர்',
  'View': 'காட்சி',
  'Everything': 'அனைத்தும்',
  'Tradition': 'மரபுச் செய்திகள்',
  'Historical': 'வரலாற்றுச் சான்றுகள்',
  'Sacred geography': 'திருத்தலப் பரப்பு',
  'See text-linked sthalams, traditional associations and independently attested places together. Journey lines are visual reconstructions, not claimed historical roads.': 'பாடல் சான்றுள்ள திருத்தலங்கள், மரபில் சொல்லப்படும் தலங்கள், தனித்த வரலாற்றுச் சான்றுள்ள இடங்கள்—மூன்றையும் ஒன்றாகப் பாருங்கள். அவற்றை இணைக்கும் கோடுகள் புரிந்துகொள்ள உதவும் காட்சி மட்டுமே; பழைய பயணச் சாலைகள் என்று கொள்ளக்கூடாது.',
  'Show sthalams linked through the Tēvāram editions and the selected saint’s pathigams.': 'தேர்ந்த நாயன்மார் பாடிய பதிகங்களுடன் தேவாரப் பதிப்புகள் இணைக்கும் திருத்தலங்களை மட்டும் காட்டுகிறது.',
  'Show birthplace, related-place and mukti-place traditions without converting them into precise historical claims.': 'பிறந்த தலம், தொடர்புடைய தலம், முக்தித் தலம் என்று மரபில் வரும் இடங்களை காட்டுகிறது; அவற்றை உறுதி செய்யப்பட்ட வரலாற்றுச் செய்தியாக மாற்றுவதில்லை.',
  'Show mapped places with independent inscriptional support and hide reconstructed routes.': 'தனித்த கல்வெட்டுச் சான்றுள்ள, வரைபடத்தில் அடையாளம் காணப்பட்ட இடங்களை மட்டும் காட்டுகிறது; ஊகித்து அமைக்கப்பட்ட பயணக் கோடுகள் மறைக்கப்படும்.',
  'Tēvāram-linked': 'தேவாரத் தொடர்புள்ளவை',
  'Traditional places': 'மரபில் சொல்லப்படும் தலங்கள்',
  'Historically attested': 'வரலாற்றுச் சான்றுள்ளவை',
  '63-Nayanmar traditional identity': 'அறுபத்து மூவர் மரபுப் பட்டியல்',
  'STORY TRADITION': 'பெரியபுராண மரபு',
  'DEVOTIONAL WORKS': 'பக்திப் பாடல்கள்',
  'Periya Puranam tradition': 'பெரியபுராண மரபு',
  'Tēvāram pathigams': 'தேவாரப் பதிகங்கள்',
  'sung sthalams': 'பாடல் பெற்ற திருத்தலங்கள்',
  'Periya Puranam chapter': 'பெரியபுராணப் பகுதி',
  'journey stops': 'பயணத் தலங்கள்',
  'Major sthalams': 'முக்கிய திருத்தலங்கள்',
  'Traditional place claims': 'மரபில் சொல்லப்படும் தலங்கள்',
  'Tirumurai 8 textual loci': 'திருமுறை 8-ல் குறிப்பிடப்படும் தலங்கள்',
  'total': 'மொத்தம்',
  'Playback progress': 'பயணத்தில் நீங்கள் இருக்கும் இடம்',
  'How to read this journey': 'இந்தப் பயணத்தைப் புரிந்துகொள்வது எப்படி?',
  'mapped districts': 'வரைபடத்தில் உள்ள மாவட்டங்கள்',
  'mapped sthalams': 'வரைபடத்தில் உள்ள திருத்தலங்கள்',
  'Map legend': 'வரைபடக் குறியீடுகள்',
  'mapped sthalam location (modern centroid)': 'திருத்தலத்தின் இன்றைய இருப்பிடம்',
  'reconstructed line between known Tēvāram-linked sthalams': 'தேவாரத் தொடர்பு தெரிந்த தலங்களை இணைக்கும் வழிகாட்டுக் கோடு',
  'traditional place sequence plays below without invented coordinates': 'மரபில் வரும் தலங்கள் வரிசையாகக் காட்டப்படுகின்றன; தெரியாத இடங்கள் ஊகித்து சேர்க்கப்படவில்லை',
  'selected-saint sthalam density by modern district': 'இந்த நாயன்மாருடன் தொடர்புடைய திருத்தலங்கள் — மாவட்ட வாரியாக',
  'independent inscriptional support': 'தனித்த கல்வெட்டுச் சான்று',
  'TRADITION PLAYBACK': 'மரபில் வரும் தல வரிசை',
  'CURRENT STHALAM': 'இப்போது பார்க்கும் திருத்தலம்',
  'Journey': 'பயணம்',
  'Overview': 'சுருக்கம்',
  'Tirumurai 8': 'திருமுறை 8',
  'CURRENT STOP': 'இப்போது பார்க்கும் இடம்',
  'Follow the selected sthalams in an exploratory sequence.': 'தேர்ந்த திருத்தலங்களை ஒன்றன்பின் ஒன்றாகப் பாருங்கள்.',
  'The line is not a claimed ancient road.': 'இந்தக் கோடு நாயன்மார்கள் சென்றதாக உறுதிப்படுத்தப்பட்ட பழைய சாலை அல்ல.',
  'Explore birthplace, related-place and mukti-place traditions.': 'பிறந்த தலம், தொடர்புடைய தலம், முக்தித் தலம் என்று மரபில் சொல்லப்படும் இடங்களைப் பாருங்கள்.',
  'No route is invented between them.': 'இவற்றை இணைக்கும் பயணப்பாதை எதையும் நாங்கள் ஊகித்து உருவாக்கவில்லை.',
  'No journey stops yet': 'இந்தப் பயணத்திற்கு இன்னும் தலங்கள் சேர்க்கப்படவில்லை',
  'Naalvar + 63-saint registry': 'நால்வரும் அறுபத்து மூவரும்',
  'Manikkavasakar is Naalvar, not a 64th Nayanmar': 'மாணிக்கவாசகர் நால்வரில் ஒருவர்; அறுபத்து மூவரின் பட்டியலில் சேர்ப்பவர் அல்ல',
  'Traditional Place Claims': 'மரபில் சொல்லப்படும் தலங்கள்',
  'TRADITION': 'மரபு',
  'Shown as claims, not coordinates or a reconstructed road.': 'இவை மரபு கூறும் தலங்கள் மட்டுமே. தெரியாத இடங்களைப் புள்ளியாகவோ பாதையாகவோ நாங்கள் ஊகித்து காட்டவில்லை.',
  'Expand ↗': 'மேலும் பார்க்க ↗',
  'Sthalam Density': 'திருத்தலங்கள் — மாவட்ட வாரியாக',
  '276 Tēvāram sthalams': '276 தேவாரத் திருத்தலங்கள்',
  'Sources & methodology': 'ஆதாரங்கள் · எப்படி தொகுத்தோம்',
  'TIRUVĀCAKAM LITERARY STHALAM': 'திருவாசகத்தில் இடம்பெறும் தலம்',
  'TRADITIONAL PLACE REFERENCE': 'மரபில் குறிப்பிடப்படும் தலம்',
  'NO ASSERTED JOURNEY CHRONOLOGY': 'பயண வரிசை உறுதி செய்யப்படவில்லை',
  'TRADITIONAL SOURCE': 'மரபு கூறும் ஆதாரம்',
  'NO MAPPED TIRUMURAI 8 LOCUS': 'திருமுறை 8-ல் இந்தத் தலக் குறிப்பு இல்லை',
  'TIRUVĀCAKAM STHALAM': 'திருவாசகத்தில் வரும் தலம்',
  'textual-locus mapping': 'பாடலில் வரும் தலத்தை வரைபடத்தில் காண்பித்தல்',
  'TIRUVĀCAKAM SECTIONS': 'திருவாசகப் பகுதிகள்',
  'JOURNEY NOTE': 'பயணக் குறிப்பு',
  'BEYOND THE PLOTTED LOCI': 'வரைபடத்தில் குறிக்கப்படாத தலங்கள்',
  'TEXTUAL LOCUS': 'பாடலில் வரும் தலம்',
  'STHALAM OVERVIEW': 'திருத்தலத்தைப் பற்றி',
  'is associated with': 'தொடர்புள்ளது',
  'contributes': 'இங்கே இடம்பெறுவது',
  'MODERN LOCATION': 'இன்றைய இருப்பிடம்',
  'SACRED REGION': 'திருத்தலப் பகுதி',
  'SUNG HERE': 'இத்தலத்தில் பாடப்பட்டவை',
  'TIRUMURAI': 'திருமுறை',
  'TRADITIONAL CHRONOLOGY': 'மரபில் வரும் காலவரிசை',
  'Place note:': 'தலத்தைப் பற்றி:',
  'selected saint': 'தேர்ந்த நாயன்மார்',
  'No Tēvāram pathigam is linked to this sthalam in the current catalogue.': 'இப்போது உள்ள பட்டியலில் இந்தத் திருத்தலத்திற்கான தேவாரப் பதிகம் எதுவும் இணைக்கப்படவில்லை.',
  'How this sthalam is documented': 'இந்தத் தலத்திற்கு என்னென்ன ஆதாரங்கள் உள்ளன?',
  'TĒVĀRAM CATALOGUE': 'தேவாரப் பட்டியல்',
  'Open catalogue entry ↗': 'தேவாரப் பதிவைப் பார்க்க ↗',
  'HISTORICAL RECORD': 'வரலாற்றுச் சான்று',
  'No linked inscription in this release': 'இந்தப் பதிப்பில் இணைக்கப்பட்ட கல்வெட்டுச் சான்று இல்லை',
  'Identification note:': 'அடையாளம் பற்றி:',
  'SOURCES · METHOD · PROVENANCE': 'ஆதாரங்கள் · தொகுப்பு முறை · மூலம்',
  'Where Nayanmar Trails gets its information': 'இந்தத் தகவல்கள் எங்கிருந்து வருகின்றன?',
  'What Pramāṇa contributes': 'பிரமாணா என்ன தருகிறது?',
  'Dataset': 'தரவுகள்',
  'Source-preserved Tēvāram text layer': 'மூல உரையை மாற்றாமல் வைத்த தேவாரப் பாடல்கள்',
  'Saint story and identity links': 'நாயன்மார் கதைகளும் அடையாளங்களும்',
  'Independent historical records': 'தனித்த வரலாற்றுச் சான்றுகள்',
  'Manikkavasakar as Naalvar': 'நால்வரில் மாணிக்கவாசகர்',
  'Text-linked': 'பாடல்/உரைச் சான்று',
  'What the editions associate with a sthalam.': 'பதிப்புகள் எந்தத் தலத்துடன் இணைக்கின்றன?',
  'Birthplace, related-place and mukti-place traditions.': 'பிறந்த தலம், தொடர்புடைய தலம், முக்தித் தலம் என்று மரபில் சொல்லப்படும் இடங்கள்.',
  'Independent inscriptional records where currently linked.': 'தற்போது இணைக்கப்பட்டுள்ள தனித்த கல்வெட்டுச் சான்றுகள்.',
  'Journey line': 'வழிகாட்டுக் கோடு',
  'Back to exploration': 'மீண்டும் சுற்றிப் பாருங்கள்',
  'TOP CONNECTIONS': 'முக்கிய தொடர்புகள்',
  'district aggregate': 'மாவட்ட வாரியான தொகுப்பு',
  'more sthalams': 'மேலும் திருத்தலங்கள்',
  'NAALVAR · TIRUMURAI 8': 'நால்வர் · திருமுறை 8',
  'Naalvar · Tirumurai 8 companion': 'நால்வர் · திருமுறை 8',
  'Tiruvācakam sections': 'திருவாசகப் பகுதிகள்',
  'source units': 'மூலப் பாடல் பகுதிகள்',
  'Tirukkōvaiyār units': 'திருக்கோவையார் பாடல் பகுதிகள்',
  'mapped textual loci': 'பாடலில் குறிப்பிடப்படும் தலங்கள்',
  'textual loci': 'பாடலில் வரும் தலங்கள்',
  'linked sthalams': 'தொடர்புள்ள திருத்தலங்கள்',
  'traditional places': 'மரபில் வரும் தலங்கள்',
  'No mapped sthalams or traditional place references are available for this selection.': 'இந்தத் தேர்வுக்கு வரைபடத்தில் காட்டக்கூடிய திருத்தலங்களோ, மரபில் சொல்லப்படும் தலங்களோ இப்போது இல்லை.',
  '798 numbered pathigams · 276 sthalams': '798 பதிகங்கள் · 276 திருத்தலங்கள்',
  'An exploratory reconstruction between known endpoints, never a claimed ancient road.': 'தெரிந்த தலங்களைப் புரிந்துகொள்ள உதவும் வழிகாட்டுக் கோடு மட்டுமே; இதை நாயன்மார்கள் நடந்த பழைய சாலை என்று கொள்ளக் கூடாது.',
  'Tēvāram': 'தேவாரம்',
  'PERIYA PURANAM': 'பெரியபுராணம்',
  'PROJECT MADURAI': 'ப்ராஜெக்ட் மதுரை',
  'DHARMA INSCRIPTIONS': 'தர்மா கல்வெட்டுகள்',
  'TIRUMURAI 8': 'திருமுறை 8',
  'SOURCES': 'ஆதாரங்கள்',
  'WHY THIS NAYANMAR IS REMEMBERED': 'இவரை நினைவில் நிறுத்தும் கதை',
  'A story from tradition': 'பெரியபுராண மரபிலிருந்து',
  'Traditional narrative — not presented as independently verified biography.': 'இது பெரியபுராண மரபில் வரும் கதை. தனித்த வரலாற்றுச் சான்றாக இதைக் கொள்ள வேண்டாம்.',
  'Read the source trail': 'ஆதாரங்களைப் பார்க்க',
  'English': 'English',
  'Tamil': 'தமிழ்',
  'Language': 'மொழி',
  'Birthplace tradition': 'பிறந்த தலம் எனும் மரபு',
  'Mukti-place tradition': 'முக்தித் தலம் எனும் மரபு',
  'Related-place tradition': 'தொடர்புடைய தலம் எனும் மரபு',
  'Search Nayanmars, sthalams, or places…': 'நாயன்மார் அல்லது திருத்தலத்தின் பெயரைத் தேடுங்கள்…',
  'No matching saint or sthalam': 'தேடிய பெயரில் நாயன்மாரோ திருத்தலமோ கிடைக்கவில்லை',
  'Naalvar · Tirumurai 8 · not numbered among the 63': 'நால்வர் · திருமுறை 8 · அறுபத்து மூவர் பட்டியலில் இல்லை',
  'Explore the traditional-place sequence below': 'மரபில் வரும் தலங்களை கீழே ஒன்றன்பின் ஒன்றாகப் பாருங்கள்',
  'Open sthalam connections': 'இந்தத் தலத்தின் தொடர்புகளைப் பார்க்க',
};

export const LocaleContext = createContext<Locale>('en');

export function useLocale() {
  return useContext(LocaleContext);
}

export function tr(locale: Locale, text: string) {
  return locale === 'ta' ? (TA[text] ?? text) : text;
}

export function T({ children }: { children: ReactNode }) {
  const locale = useLocale();
  if (typeof children !== 'string') return <>{children}</>;
  return <>{tr(locale, children)}</>;
}
